import { Component, forwardRef, inject, Input } from '@angular/core';
import { AbstractFormControl } from '../abstract-form-control';
import { CheckpointGroupItemDto, CheckpointGroupService, SortDto } from '@artemis-software/wr-api';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { asyncComputed } from '@/utils/signals/asyncComputed';
import { Tracked } from '@/utils/signals/tracked';
import { map, of } from 'rxjs';

@Component({
  standalone: false,
  selector: 'wr-checkpoint-group-select',
  templateUrl: './checkpoint-group-select.component.html',
  styleUrls: ['./checkpoint-group-select.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CheckpointGroupSelectComponent),
      multi: true,
    },
  ],
})
export class CheckpointGroupSelectComponent extends AbstractFormControl<string> {

  @Input()
  @Tracked()
  tenantId: string | undefined;

  readonly checkpointGroupService = inject(CheckpointGroupService);

  readonly checkpointGroups = asyncComputed(() => {
    if(!this.tenantId) {
      return of([] as CheckpointGroupItemDto[]);
    }
    return this.checkpointGroupService.findAll({
      tenantId: this.tenantId,
      sort: { sort: 'number', order: SortDto.OrderEnum.Asc }
    })
      .pipe(
        map(groups => groups.filter(group => !group.deprecated))
      );
  });

  @Input()
  showEmptyOption = false;
}
